// src/CustomThemeProvider.js
import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import {
    defaultLightTheme,
    blueLightTheme,
    greenLightTheme,
    defaultDarkTheme,

} from './themelist';
import { CssBaseline } from '@mui/material';

const getTheme = (color) => {
    switch (color) {
        case 'default':
            return defaultLightTheme;
        case 'blue':
            return blueLightTheme;
        case 'green':
            return greenLightTheme;
        case 'dark':
            return defaultDarkTheme;
        default:
            return defaultLightTheme;
    }
};  

const CustomThemeProvider = ({ children }) => {
    const  {color}  = useSelector((state) => state.theme);
    const theme = getTheme(color);  

    return <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
    </MuiThemeProvider>;
};

export default CustomThemeProvider;
